import type { IDurationData } from "app/services/DurationService";
import dayjs from "dayjs";
import type { ITotalVisits } from "app/pages/industry-analysis/overview/utils/types";

const CURRENT_PERIOD_INDEX = 0;
const COMPARED_PERIOD_INDEX = 1;

const EMPTY_STATE = {
    currPeriod: {
        totalVisits: null,
        change: null,
        barHeight: null,
    },
    comparedPeriod: {
        totalVisits: null,
        change: null,
        barHeight: null,
    },
};

export const adaptPOPBarChartData = (data: Array<ITotalVisits>) => {
    if (!data || data.length === 0 || !Array.isArray(data)) {return EMPTY_STATE;}
    const currentPeriodRecord = data[CURRENT_PERIOD_INDEX];
    const comparedPeriodRecord = data[COMPARED_PERIOD_INDEX];
    if (!currentPeriodRecord || !comparedPeriodRecord) {return null;}

    const currentPeriodVisits = currentPeriodRecord.Value;
    const comparedPeriodVisits = comparedPeriodRecord.Value;
    const isCurrentPeriodBiggest = currentPeriodVisits > comparedPeriodVisits;

    return {
        currPeriod: {
            totalVisits: currentPeriodVisits,
            change: currentPeriodRecord.Change,
            barHeight: isCurrentPeriodBiggest ? "100%" : `${(currentPeriodVisits / comparedPeriodVisits) * 100}%`,
        },
        comparedPeriod: {
            totalVisits: comparedPeriodVisits,
            barHeight: isCurrentPeriodBiggest ? `${(comparedPeriodVisits / currentPeriodVisits) * 100}%` : "100%",
        },
    };
};

const getFormattedDate = (date) => {
    return dayjs(date.split("|").join("-")).format("MMM YY"); // gets date in format "yyyy|mm|dd" and returns it in format: "MMM YY"
};

const getBarChartDurationLabels = (duration: IDurationData) => {
    const current = `${getFormattedDate(duration.forAPI.from)} - ${getFormattedDate(duration.forAPI.to)}`;
    const compared = `${getFormattedDate(duration.forAPI.compareFrom)} - ${getFormattedDate(
        duration.forAPI.compareTo,
    )}`;
    return {
        currentDuration: current,
        comparedDuration: compared,
    };
};
